<template>
    <div class="products px-360 px-xs-32">
        <XSTitle :main="yyMessage" :sub="titEN" class="hidden-sm-and-up"></XSTitle>
        <el-tabs v-model="activeName" :tab-position="wWidth<768?tabPosition[1]:tabPosition[0]" @tab-click="handleClick" :before-leave="beforeLeave">
            <el-tab-pane 
            v-for="item in activeProducts"
            :key="item.name"
            :name="item.name"
            >
                <span slot="label">
                    {{labelChange(item.label)}}<br v-show="wWidth<768 && wWidth>300 && /VR/.test(item.label) || wWidth<768 && wWidth>200 && /云/.test(item.label)">{{brDetail(item.label)}}
                    <i class="el-icon-arrow-right hidden-xs-only" v-show="item.icon"></i>
                    <i class="el-icon-arrow-down hidden-xs-only" v-show="item.icon!=undefined&&!item.icon"></i>
                    <i class="el-icon-plus hidden-sm-and-up" v-show="item.icon"></i>
                    <i class="el-icon-minus hidden-sm-and-up" v-show="item.icon!=undefined&&!item.icon"></i>
                </span>
                <h1>{{/^设备|^性能/.test(item.label)?"MRI"+item.label:item.label}}</h1>
                <!-- pc的意思是 product content -->
                <component v-if="activeName == item.name" :is="item.com" class="pc"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import XSTitle from '../eyTitXs.vue'
export default {
    data() {
      return {
        yyMessage: '软件产品',
        titEN: 'SOFTWARE PRODUCTS',
        tabPosition: ['left','top'],

        // 1----新增按钮规则：
        // 父子菜单写入proItem，父子菜单增加对应components
        // 父菜单：flag:true,icon:true  flag代表是否可以折叠，icon代表折叠展开图标
        // 2----点击折叠展开规则：
        // 详见handleClick、unflag
        // 3----样式增加规则：
        // 父菜单样式：(外按钮) #tab-name
        // 所有子菜单：(内按钮) #tab-name
        // 第一个子菜单：(内按钮第一个) #tab-name
        // 最后一个子菜单：(内按钮最后一个) #tab-name

        // proItem索引见下
        // vr 0 / 
        // device 1 / deviceMRI 2 / deviceCT 3 / deviceDR 4 /
        // performance 5 / perMRI 6/ perCT 7 / perDR 8 / 
        // check 9 / checkMRI 10 / checkCT 11 / checkDR 12
        // photo 13 / pacs 14 / course 15
        // noEvent1 16 / noEvent11 17 / noEvent12 18 / noEvent13 19 
        proItem:[
            {label:'医学影像中心VR系统',name:'vr',flag:true,com:"com0"},
            {label:'设备结构虚拟仿真系统',name:'device',flag:true,icon:true,com:"com2"},
            {label:'MRI设备结构虚拟仿真系统',name:'deviceMRI',flag:false,com:"com2"},
            {label:'CT设备结构虚拟仿真系统',name:'deviceCT',flag:false,com:"com3"},
            {label:'DR设备结构虚拟仿真系统',name:'deviceDR',flag:false,com:"com4"},
            {label:'性能检测虚拟仿真系统',name:'performance',flag:true,icon:true,com:"com6"},
            {label:'MRI性能检测虚拟仿真系统',name:'perMRI',flag:false,com:"com6"},
            {label:'CT性能检测虚拟仿真系统',name:'perCT',flag:false,com:"com7"},
            {label:'DR性能检测虚拟仿真系统',name:'perDR',flag:false,com:"com8"},
            {label:'检查技术虚拟仿真系统',name:'check',flag:true,icon:true,com:"com13"},
            {label:'MRI检查技术虚拟仿真系统',name:'checkMRI',flag:false,com:"com13"},
            {label:'CT检查技术虚拟仿真系统',name:'checkCT',flag:false,com:"com14"},//com14
            {label:'DR检查技术虚拟仿真系统',name:'checkDR',flag:false,com:"com15"},//com15
            {label:'成像原理虚拟仿真系统',name:'photo',flag:true,com:"com10"},
            {label:'医学影像诊断思维教学系统',name:'pacs',flag:true,com:"com11"},
            {label:'医学图像处理教学系统',name:'course',flag:true,com:"com12"},
            // {label:'检查技术虚拟仿真系统',name:'noEvent1',flag:true,icon:true,com:""},
            // {label:'MRI检查技术虚拟仿真系统',name:'noEvent11',flag:false,com:""},
            // {label:'CT检查技术虚拟仿真系统',name:'noEvent12',flag:false,com:""},
            // {label:'DR检查技术虚拟仿真系统',name:'noEvent13',flag:false,com:""},
            {label:'医学影像解剖图谱',name:'dissect',flag:true,com:"com16"},
        ],
        wWidth: window.screen.width,
      }
    },
    components:{
        // com1 com5是空的 proItem没有label与其对应
        com0: () => import("@/components/products/vr.vue"),// 医学影像中心VR系统
        com1: () => import("@/components/products/device.vue"),
        com2: () => import("@/components/products/deviceMRI.vue"),// MRI设备结构
        com3: () => import("@/components/products/deviceCT.vue"),// CT设备结构
        com4: () => import("@/components/products/deviceDR.vue"),// DR设备结构
        com5: () => import("@/components/products/performance.vue"),
        com6: () => import("@/components/products/perMRI.vue"),// MRI性能检测
        com7: () => import("@/components/products/perCT.vue"),// CT性能检测
        com8: () => import("@/components/products/perDR.vue"),// DR性能检测
        com9: () => import("@/components/products/check.vue"),// **检查技术虚拟仿真系统 暂无，隐藏了
        com10: () => import("@/components/products/photo.vue"),// **成像原理虚拟仿真系统 暂无，隐藏了
        com11: () => import("@/components/products/pacs.vue"),// 医学影像诊断思维教学系统
        com12: () => import("@/components/products/course.vue"),// 医学图像处理教学系统
        com13: () => import("@/components/products/checkMRI.vue"),// MRI检查技术
        com14: () => import("@/components/products/checkCT.vue"),// CT检查技术
        com15: () => import("@/components/products/checkDR.vue"),// DR检查技术
        com16: () => import("@/components/products/dissect.vue"),// 影像解剖
        XSTitle
    },
    created(){
        // console.log(this.atN)
    },
    computed:{
        // 不要用Vuex的mapState 浏览器会Warn
        // 因为Vuex是单向，state只能通过mutation更改，而v-model是双向
        activeName:{
            get(){
                return this.$store.state.toTab.atN
            },
            set(val){
                this.$store.state.toTab.atN = val
            }
        },
        // 隐藏需要折叠的tab
        activeProducts: function () {
            return this.proItem.filter(function (pro) {
                return pro.flag;//返回flag=true的项，添加到activeProducts数组
            })
        }
    },
    methods:{
        // 屏宽小于768 菜单栏减字
        labelChange(label){
            if(this.wWidth<768 && /MRI/.test(label)){
                return 'MRI'
            }else if(this.wWidth<768 && /CT/.test(label)){
                return 'CT'
            }else if(this.wWidth<768 && /DR/.test(label)){
                return 'DR'
            }else if(this.wWidth<768 && /虚拟/.test(label)){
                return label.substring(0,4)
            }else if(this.wWidth<768 && /VR/.test(label)){
                return label.substring(0,6)
            }else if(this.wWidth<768 && /云/.test(label)){
                return label.substring(0,4)
            }else{
                return label
            }
            // return this.wWidth<768 && /虚拟/.test(label)?label.substring(0,4):label
        },

        brDetail(brD){
            if(this.wWidth<768){
                if(/VR/.test(brD)){
                    return brD.substring(6)
                }else if(/云/.test(brD)){
                    return brD.substring(4)
                }
            }else{
                return ''
            }
        },
        // 展开与折叠判断  真假取反
        unflag(para,start,end,others){
            for(let i=start;i<end+1;i++){
                para[i].flag = !para[i].flag
            }

            if(start === 2){
                for (let i = 6; i < 9; i++) {
                    para[i].flag = false
                }
                for (let i = 10; i < 13; i++) {
                    para[i].flag = false
                }
                this.proItem[5].icon = true
                this.proItem[9].icon = true

            }else if(start === 6){
                for (let i = 2; i < 5; i++) {
                    para[i].flag = false
                }
                for (let i = 10; i < 13; i++) {
                    para[i].flag = false
                }
                this.proItem[1].icon = true
                this.proItem[9].icon = true

            }else if(start === 10){
                for (let i = 2; i < 5; i++) {
                    para[i].flag = false
                }
                for (let i = 6; i < 9; i++) {
                    para[i].flag = false
                }
                this.proItem[1].icon = true
                this.proItem[5].icon = true
            }

        },

        // 展开与折叠动效
        handleClick(tab,event){
            if(tab.name=="device"){
                this.unflag(this.proItem,2,4)// 后两个参数是子菜单在proItem的索引
                // 展开与折叠后的 角标切换 > v
                this.proItem[1].icon = !this.proItem[1].icon// 这一个索引是父菜单在proItem的索引
            }else if(tab.name=="performance"){
                this.unflag(this.proItem,6,8)
                this.proItem[5].icon = !this.proItem[5].icon
            }else if(tab.name=="check"){
                this.unflag(this.proItem,10,12)
                this.proItem[9].icon = !this.proItem[9].icon
            }
            // else if(tab.name=="noEvent1"){
            //     this.unflag(this.proItem,17,19)
            //     this.proItem[16].icon = !this.proItem[16].icon
            // }
            // else if(tab.name=="photo"){

            // }
        },

        // 当按钮涉及noEvent，禁止点击
        beforeLeave(newI,oldI){
            if(/noEvent/.test(newI)){
                return false
            }
        }

    },
}
</script>

<style lang="scss" scoped>
.products{
    margin: vw(20) 0 vw(28);

    // .iconToggle-enter-active,.iconToggle-leave-active{
    //     transition: all .25s ease;
    // }

    ::v-deep {
        .el-tabs--left .el-tabs__header.is-left{
            margin-right: vw(20);
        }

        .el-tab-pane .bgBlueF3,
        .el-tab-pane h1,
        .el-tabs__nav{
            background: $blueF3;
        }

        .el-tabs__nav{
            width: vw(240);
            padding: vw(20) vw(10);
        }

        .el-tabs__item{
            font-size: vw(16);
            padding: 0 vw(22);
            margin-bottom: vw(10);
            height: auto;
            font-weight: 500;
            line-height: 3;
            text-align: center;
            color: $blue096;
            background: white;
            border: 1px solid $blue096;
            border-radius: vw(5);

            @media only screen and (min-width: 768px) and (max-width: 1199px){
                line-height: 2;
                white-space: normal;
            }

            &:hover,
            &.is-active{
                color: white;
                background: $blue096;
            }
        }

        // 外按钮
        #tab-device,
        #tab-performance,
        #tab-check,
        #tab-photo,
        #tab-noEvent1{
            i{
                padding-left: vw(12);
            }

            &:hover,
            &.is-active{
                &::after{
                    color: white;
                }
            }

        }

        // 内按钮第一个
        #tab-deviceMRI,
        #tab-perMRI,
        #tab-checkMRI,
        #tab-noEvent11{
            margin-top: vw(20);
        }

        // 内按钮样式
        #tab-deviceMRI,
        #tab-deviceDR,
        #tab-deviceCT,
        #tab-perMRI,
        #tab-perDR,
        #tab-perCT,
        #tab-checkMRI,
        #tab-checkCT,
        #tab-checkDR,
        #tab-noEvent11,
        #tab-noEvent12,
        #tab-noEvent13{
            color: $font66;
            margin-bottom: vw(11);
            background: transparent;
            border: none;

            &:hover,
            &.is-active{
                color: $blue096;
                // background: $blue096;
            }
        }

        // 内按钮最后一个
        #tab-deviceDR,
        #tab-perDR,
        #tab-checkDR,
        #tab-noEvent13{
            margin-bottom: vw(15);
        }
        
        .el-tabs__active-bar,
        .el-tabs__nav-wrap::after,
        // #tab-check,
        #tab-photo{
            display: none;
        }

        // ---------------  内容  ---------------
        .el-tabs__content{
            max-width: vw(940);

            // &::before{
            //     // \00A0是空格
            //     content: 'Product\00A0\00A0\00A0\00A0introduction';
            //     font-size: vw(48);
            //     position: absolute;
            //     top: vw(26);
            //     left: vw(186);
            //     font-weight: bold;
            //     line-height: 1.25;
            //     color: rgba(211, 226, 244, 0.5);
            //     transform: translateZ(2px);
            //     // z-index: -1;
            // }

            h1{
                position: relative;
                font-size: vw(30);
                margin: 0;
                padding-top: vw(28);
                line-height: 2;
                color: $font18;
                z-index: 2;
                
                &::before{
                    // \00A0是空格
                    content: 'Product\00A0\00A0\00A0\00A0introduction';
                    font-size: vw(48);
                    position: absolute;
                    top: vw(26);
                    left: vw(186);
                    font-weight: bold;
                    line-height: 1.25;
                    color: rgba(211, 226, 244, 0.5);
                    z-index: -1;
                }
            }
        }

        .pc{
            p{
                font-size: vw(18);
                text-align: left;
                text-indent: 2em;
                color: $font23;
                line-height: 2.5;
            }

            p:first-child{
                margin-top: 0;
                padding-top: 1rem;
            }
        }
    }

    // -------------------------------  手机端  -------------------------------

    @media only screen and (max-width: 767px){
        // margin-top: vp(-313);
        margin-top: vp(-270);
        margin-bottom: vp(30);

        ::v-deep {
            .el-tabs__header{
                margin: 0 0 vp(45);
            }

            .el-tabs__nav-wrap{
                margin-right: vp(-32);
            }

            .el-tabs__nav{
                display: flex;
                // justify-content: space-between;
                flex-wrap: wrap;
                padding: 0;
                width: 100%;
                background: transparent;
            }

            .el-tabs__item{
                font-size: vp(30);
                // padding: vp(20) vp(14);
                // padding: vp(20) 0;
                margin-right: vp(12);
                margin-bottom: vp(14);
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: vp(120);
                width: 30%;
                box-sizing: border-box;
                white-space: normal;
                line-height: 1.3;
                border-radius: vp(5);
            }

            #tab-deviceMRI,
            #tab-perMRI{
                margin-top: 0;
            }

            // #tab-deviceMRI,
            // #tab-deviceCT,
            // #tab-deviceDR{
            //     position: absolute;
            //     left: vp(267);
            // }

            #tab-device,
            #tab-performance,
            #tab-check,
            #tab-photo{
                i{
                    padding-left: 0;
                }
            }

            // div[id*="tab-"]{
            //     display: flex;
            //     align-items: center;
            //     min-height: vp(120);
            //     max-width: vp(230);
            //     width: 30%;
            //     white-space: normal;
            // }

            .el-tabs__nav-wrap.is-scrollable {
                padding: 0;
            }

            .el-tabs__nav-prev,
            .el-tabs__nav-next{
                display: none;
            }

            .el-tabs--top .el-tabs__item.is-top{

                &:nth-child(2){
                    // padding-left: vp(12);
                }

                &:last-child{
                    padding-right: vp(12);
                }
            }

            .el-tabs__content{
                max-width: 100%;
                // margin-left: vp(-32);
                // margin-right: vp(-32);

                h1{
                    font-size: vp(36);
                    padding-top: vp(60);
                    line-height: 1.6;

                    &::before{
                        display: none;
                    }
                }

                .pc{
                    p{
                        font-size: vp(30);
                        line-height: 1.8;
                    }

                    .refer{
                        span{
                            font-size: vp(24);
                            margin-bottom: vp(30);
                        }
                        
                    }
                }
            }
        }
    }
}

</style>